<template>
  <vx-card>
    <div class="add-attendents" style="display:none;">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full lg:w-full mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <img
            src="@/assets/images/elements/decore-left.png"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            src="@/assets/images/elements/decore-right.png"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">Event created successfully!</h1>
          <p
            class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white"
          >Congratulations, your event configuration is completed!!</p>
        </vx-card>
      </div>
      <vs-button class="float-right" @click="handleAttendents">ADD ATTENDANTS</vs-button>
      <br />
      <br />
    </div>
    <div class="download-sample">
      <h4>Import contact :</h4>
      <br />
      <p>Prepare excel document with following format :</p>
      <div class="vx-row">
        <vs-table :data="users" class="vx-col md:w-1/2 w-full mt-5">
          <template slot="thead">
						<vs-th>First Name</vs-th>
						<vs-th>Last Name</vs-th>
						<vs-th>Id Number</vs-th>
						<vs-th>Email</vs-th>
						<vs-th>Mobile Number</vs-th>
						<vs-th>Weight</vs-th>
						<vs-th>Delegated For</vs-th>
						<vs-th>Moderator</vs-th>
						<vs-th>Speaker</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<vs-td :data="data[indextr].first_name">{{data[indextr].first_name}}</vs-td>
							<vs-td :data="data[indextr].last_name">{{data[indextr].last_name}}</vs-td>
							<vs-td :data="data[indextr].id_number">{{data[indextr].id_number}}</vs-td>
							<vs-td :data="data[indextr].email">{{data[indextr].email}}</vs-td>
							<vs-td :data="data[indextr].mobile_no">{{data[indextr].mobile_no}}</vs-td>
							<vs-td :data="data[indextr].weight">{{ data[indextr].weight }}</vs-td>
							<vs-td :data="data[indextr].delegated_for">{{ data[indextr].delegated_for }}</vs-td>
							<vs-td :data="data[indextr].is_moderator">{{ data[indextr].is_moderator }}</vs-td>
							<vs-td :data="data[indextr].is_speaker">{{ data[indextr].is_speaker }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-button class="float-right" @click="handleSample">DOWNLOAD THE SAMPLE</vs-button>
        </div>
        <br />
        <br />
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-full w-full mt-5">
          <vs-button class="float-right" @click="handleContinue">CONTINUE</vs-button>
        </div>
      </div>
    </div>
    <div class="upload-file" style="display:none">
      <h4>Upload File :</h4>
      <br />
      <div>
        <div class="mb-8">
          <import-excel :onSuccess="loadDataInTable" />
        </div>
        <div v-if="tableData.length && header.length">
          <vs-table
            multiple
            v-model="selected"
            pagination
            :max-items="100"
            search
            :data="tableData"
          >
            <template slot="header">
              <h4>Invitees :</h4>
            </template>

            <template slot="thead">
              <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td
                  v-for="heading in header"
                  :key="heading"
                >{{ tr[heading] }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <br />
          <div class="float-right">
            <span
              style="margin-right:15px;"
            >Do you want to send {{selected.length}} invites via email?</span>
            <vs-button @click="handleInvitation">Confirm</vs-button>
          </div>
          <br />
          <br />
        </div>
      </div>
    </div>
    <div class="invites-success" style="display:none">
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <h4>Sending invitation</h4>
          <br />
          <p>we will be sending {{selected.length}} invites to your event shortly</p>
          <br />
          <vs-progress class="block mt-1" :percent="percent_completed" color="primary"></vs-progress>
          <br />
          <div class="success-msg" style="color:green;display:none">
            <span>Invitations sent successfully!!</span>
            <vs-button class="float-right" @click="back">Go to Dashboard</vs-button>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>


<script>
import $ from "jquery";
import { Validator } from "vee-validate";
import ImportExcel from "@/components/excel/ImportExcel.vue";

const dict = {
  custom: {
    invite_file: {
      required: "File is required",
      ext: "Only csv, xls, xlsx file allowed"
    }
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
  data() {
    return {
      percent_completed: 10,
      users: [
        {
          first_name: "Mario",
          last_name: "Rossi",
          id_number: 9931314,
          email: "mario@ex.com",
          mobile_no: "347 7777777",
					delegated_for: "77931315",
          right_to_vote: "1",
        },
        {
          first_name: "Lusia",
          last_name: "Bianchi",
          id_number: 77931314,
          email: "lusia@ex.com",
          mobile_no: "347 888888",
					delegated_for: "77931315",
          right_to_vote: "0"
        }
      ],
      file: null,
      selected: [],
      event_id: "",
      tableData: [],
      header: [],
      sheetName: ""
    };
  },
  created() {
    this.event_id = this.$route.params.id;
  },
  methods: {
    /**
     * Read excle file data and display in table format
     * @author Madhura Shah
     */
    loadDataInTable({ results, header, meta }) {
      console.log(this.tableData);
      console.log(this.header);

      this.header = header;
      this.tableData = this.selected = results;
      this.sheetName = meta.sheetName;
      console.log(this.tableData);
      console.log(this.header);
    },

    /**
     * Store selcted file
     * @author Madhura Shah
     */
    selectedFile(event) {
      this.file = event.target.files[0];
    },

    /**
     * On add attendants button show download sample file div
     * @author Madhura Shah
     */
    handleAttendents() {
      $(".add-attendents").hide();
      $(".download-sample").show();
    },

    /**
     * Dwonload sample file
     * @author Madhura Shah
     */
    handleSample() {
      this.$vs.loading();
      this.$store
        .dispatch("downloadFile")
        .then(res => {
          this.$vs.loading.close();
          var data = res.data;
          // Success response
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            "symposium_invitation_template.xlsx"
          );
          document.body.appendChild(fileLink);

          fileLink.click();

          this.$vs.notify({
            color: "success",
            title: "Download Success",
            text: "File downloaded successfully!!",
            position: "top-center"
          });
        })
        .catch(error => {
          this.$log.error('File : Invite.vue | Function : handleSample() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to download file, please try again",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },

    /**
     * On continue btton click show file upload div
     * @author Madhura Shah
     */
    handleContinue() {
      $(".download-sample").hide();
      $(".upload-file").show();
    },

    /**
     * Progress bar incress function
     * @author Madhura Shah
     */
    increase() {
      this.percent_completed = this.percent_completed + 10;
    },

    /**
     * Import selected users
     * @author Madhura Shah
     */
    handleInvitation() {
      console.log(this.selected);
      if (this.selected.length > 0) {
        $(".upload-file").hide();
        $(".invites-success").show();
        var percent = setInterval(() => {
          this.increase();
        }, 1000);

        const selected = this.selected.map(_item =>
          ({
            email: `${_item['Email']}`.trim(),
            first_name: `${_item['First Name']}`.trim(),
            last_name: `${_item['Last Name']}`.trim(),
            id_number: `${_item['Id Number']}`.trim(),
            mobile_number: `${_item['Mobile Number']}`.trim(),
            weight: `${_item['Weight']}`.trim() || `${_item['Right To Vote']}`.trim(),
            delegated_for: `${_item['Delegated For']}`.trim() || null,
            is_moderator: `${_item['Moderator']}`.trim().toLowerCase()=='yes' ? 1 : 0,
            is_speaker: `${_item['Speaker']}`.trim().toLowerCase()=='yes' ? 1 : 0
          })
        );


        let data = {
          event_id: this.event_id,
          users: selected
        };

        this.$store
          .dispatch("importUsers", data)
          .then(() => {
            this.percent_completed = 100;
            this.$vs.notify({
              color: "success",
              text: "Invitation sent successfully!!",
              position: "top-center"
            });
            $(".success-msg").show();
            clearInterval(percent);
          })
          .catch(error => {
            this.$log.error('File : Invite.vue | Function : handleInvitation() | Error :', error);
            // Error response
            this.$vs.notify({
              title: "Failed to send invitation, please try again",
              text: error,
              color: "danger",
              position: "top-center"
            });
            return false;
          });
      } else {
        return false;
      }
    },

    /**
     * Back to dashboard button
     * @author Madhura Shah
     */
    back() {
      this.$router.push({ path: "/admin/dashboard" });
    }
  },
  components: {
    ImportExcel
  }
};
</script>
